import { BehaviorSubject } from 'rxjs';

import { Config } from './config';
import { HandleResponse } from './handleResponse';

const isServer = typeof window === 'undefined';

// const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));
const currentUserSubject = new BehaviorSubject(getStoredUser());

function getStoredUser() {
  if (isServer) return null;
  try {
    const raw = localStorage.getItem('currentUser');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export const AuthenticationService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue () { return currentUserSubject.value }
};

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
        credentials: 'include'
    };

    return fetch(`${Config.apiUrl}/login/`, requestOptions)
        .then(HandleResponse)
        .then(user => {
            if (isServer) return;
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
            currentUserSubject.next(user);

            return user;
        });
}

function logout() {
    if (isServer) return;

    fetchWithCredentials(`${Config.apiUrl}/logout/`, {
        method: 'POST'
    });

    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    currentUserSubject.next(null);
}

export const fetchWithCredentials = (url, options = {}) => {
    console.log("FETCH", {
        pageOrigin: window.location.origin,
        url,
    });

    let headers = 
    {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    return fetch(url, {
        headers: headers, 
        ...options,
        credentials: 'include',
    });
};